<template>
    <footer class="footer">
        <div class="footer-body">
            <v-container>
                <v-row justify="space-between">
                    <v-col cols="12" md="">
                        <v-row class="row--sm">
                            <v-col cols="12">
                                <div class="pb-md-6px">
                                    <v-img eager max-width="115" :aspect-ratio="115/54" src="/images/logo.svg" />
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <div class="inline-group">
                                    <ul>
                                        <li><div class="font-weight-medium white--text mb-12px">IReis Co., Ltd.</div></li>
                                        <li class="clear"><span class="grey--text text--lighten-3">Head Office </span>931, 285 Gangneung-daero, Gangneung-si, Gangwon-do, Republic of Korea</li>
                                        <!-- <li class="clear"><span class="grey--text text--lighten-3">R&D Center </span>1024 & 1025, Building C, Munjeong Hyundai Knowledge Industry Center, 7 Beobwon-ro 11-gil, Songpa-gu, Seoul, Republic of Korea</li> -->
                                        <li class="clear"><span class="grey--text text--lighten-3">Gyeonggi Factory </span>203, Pyeongchon Digital Empire, 16 Heungan-daero 427beon-gil, Dongan-gu, Anyang-si, Gyeonggi-do, Republic of Korea</li>
                                        <!-- <li class="clear"><span class="grey--text text--lighten-3">Gyeongnam Branch </span>C-529, 12 Dongbu-ro 169beon-gil, Jinju-si, Gyeongsangnam-do, Republic of Korea</li> -->
                                        <li class="clear"><span class="grey--text text--lighten-3">Telephone </span>+82-70-8680-0950</li>
                                        <li><span class="grey--text text--lighten-3">Fax </span>+82-31-423-0483</li>
                                        <li><span class="grey--text text--lighten-3">E-mail </span>ireis@ireis.co.kr</li>
                                    </ul>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <div class="footer-copyright">
                                    <p>Copyright 2023. Ireis All Rights Reserved.</p>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="auto" class="d-flex ml-auto">
                        <v-row align-content="space-between" class="flex-column">
                            <!-- <v-col class="d-none d-md-block">
                                <v-img max-width="114" src="/images/logo.svg" class="ml-auto" />
                            </v-col> -->
                            <v-col class="d-flex">
                                <v-row justify="end" class="row--sm mt-auto">
                                    <v-col cols="auto">
                                        <v-btn x-small fab color="grey" href="https://blog.naver.com/ireis2010" target="_blank"><i class="icon icon-blog" /></v-btn>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn x-small fab color="grey" href="https://www.youtube.com/@user-ob6uq3jz6u" target="_blank"><i class="icon icon-youtube" /></v-btn>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn x-small fab color="grey" href="https://www.facebook.com/ireis0903" target="_blank"><i class="icon icon-facebook" /></v-btn>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn x-small fab color="grey" href="https://www.instagram.com/ireis_official/" target="_blank"><i class="icon icon-insta" /></v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </footer>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.inline-group {
    > ul {
        > li {
            font-size: 16px;
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .inline-group {
        > ul {
            > li {
                font-size: 18px;
            }
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
